/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const analyticsModule = require('@utils/analytics/analyticsModule');
const commonModule = require('@utils/common/commonModule');
const indexModule = require('@utils/index/indexModule');
const productModule = require('@utils/product/productModule');
const HomeAdvisorModalService = require('./homeAdvisorModalService');
const homeAdvisorModalDirective = require('./homeAdvisorModalDirective');

const homeAdvisorModule = angular
    .module('enervee_utils.home_advisor', [
        analyticsModule.name,
        commonModule.name,
        indexModule.name,
        productModule.name,
    ])
    .factory('HomeAdvisorModalService', HomeAdvisorModalService)
    .directive('homeAdvisorModal', homeAdvisorModalDirective);

module.exports = homeAdvisorModule;
